import { SurveyPostAnswerMetaSvend } from '@surveycake/logic-engine';
import { SurveyConfig } from 'app/core/survey-config';
import endedbannerImage from 'images/banner/ended.jpg';
import sorrybannerImage from 'images/banner/sorry.jpg';
import thankyoubannerImage from 'images/banner/thankyou.jpg';

type Config = {
  [type in SurveyPostAnswerMetaSvend]: (
    surveyConfig: SurveyConfig
  ) => {
    banner: string;
    text: string;
  };
};

export const config: Config = {
  thankyou: surveyConfig => ({
    banner: surveyConfig.data.thankyoubanner || thankyoubannerImage,
    text:
      surveyConfig.translation.thankyoutext ||
      surveyConfig.data.thankyoutext ||
      ''
  }),
  ended: surveyConfig => ({
    banner: endedbannerImage,
    text:
      surveyConfig.translation.endedtext ||
      surveyConfig.data.endedtext ||
      ''
  }),
  sorry: surveyConfig => ({
    banner: sorrybannerImage,
    text:
      surveyConfig.translation.sorrytext ||
      surveyConfig.data.sorrytext ||
      ''
  })
};
